import axios from 'axios';

export function getUserScreensCount(token, userId) {
    return axios.get(`${process.env.REACT_APP_API_URL}/getUserScreensCount?userId=${userId}`, {
        headers: { Authorization: `${token}` },
    });
}
